

export const HistorialCarga =[
      {
        Header: "No. de Guía",
        accessor: "Guiahija"
      },
      {
        Header: "Estado",
        accessor: "DescripcionEgeo"
      },
      {
        Header: "Boleta/Factura",
        accessor: "Boleta"
      },
      {
        Header: "casilla",
        accessor: "Recepcion"
      },
      {
        Header: "No de Dips *",
        accessor: "Dips"
      },
      {
        Header: "Tienda",
        accessor: "proveedor"
      },
      {
        Header: "Descripcion",
        accessor: "descripcionProducto"
      },
      {
        Header: "Peso (kgs)",
        accessor: "Peso_Efectivo"
      },
      {
        Header: "Valor FOB (USD)",
        accessor: "Valor_Fob"
      },
      {
        Header: "Visualizar Dip",
        accessor: "VerDips"
      },
      {
        Header: "Visualizar Despacho",
        accessor: "urlDespacho"
      }
      ,
      {
        Header: "Tracking",
        accessor: "Tracking"
      }
      
    ];


    export const HistorialInicial={
      guia:"-",
      Estado:"-",
      Boleta:"-",
      Dips:"-",
      Tienda:"-",
      descripcionProducto:"-",
      Peso_Efectivo:"-",
      Valor_Fob:"-",
      Tracking:"-"
    }
